import React from 'react';
import { FormikRadioInput as Radio, DietModeType } from '@front-activerse/common-components';
import { useTranslator } from '@front-activerse/common-components';

export const DietMode: React.FC = () => {
  const { t } = useTranslator();

  return (
    <>
      <h2 className="mb-xl title-large semi-bold">{t('app.goalSettings.goal.headline')}</h2>

      <Radio name="dietMode" value={DietModeType.slimming}>
        <strong>{t('app.goalSettings.goal.optionWeightLoss.title')}</strong>
        <p className="mb-0">{t('app.goalSettings.goal.optionWeightLoss.description')}</p>
      </Radio>

      <Radio name="dietMode" value={DietModeType.stabilization}>
        <strong>{t('app.goalSettings.goal.optionWeightMaintain.title')}</strong>
        <p className="mb-0">{t('app.goalSettings.goal.optionWeightMaintain.description')}</p>
      </Radio>

      <Radio name="dietMode" value={DietModeType.gain_muscle_mass}>
        <strong>{t('app.goalSettings.goal.optionBuildMuscle.title')}</strong>
        <p className="mb-0">{t('app.goalSettings.goal.optionBuildMuscle.description')}</p>
      </Radio>
    </>
  );
};

export default DietMode;
